import { render, staticRenderFns } from "./admin-student-referral-show.vue?vue&type=template&id=261b940b&scoped=true"
import script from "./admin-student-referral-show.vue?vue&type=script&lang=js"
export * from "./admin-student-referral-show.vue?vue&type=script&lang=js"
import style0 from "./admin-student-referral-show.vue?vue&type=style&index=0&id=261b940b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b940b",
  null
  
)

export default component.exports